/** @format */

export const Spinner1 = () => {
  return (
    <div className="loading">
      <div className="bg-loading">
      <div className='lds-roller'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      </div>
    </div>



  );
};
